import React, { Component, Fragment } from "react";
import { Link, withRouter,Redirect } from "react-router-dom";
import ReactDOM from 'react-dom';
import Modal from 'react-responsive-modal';
import api from "../../../services/api"



class Map extends Component {
  
    state = {
      idmatricula: this.props.truemodaledit,
        observacao:null,
        id:null,

      };
     
     
      onCloseModal = () => {
        this.setState({ open: false,error:"" });

        
       
      };

      componentDidUpdate(prevProps, prevState, snapshot)
      {
        if(prevProps.truemodaledit!==this.props.truemodaledit){

          this.invokeinitial(prevProps.truemodaledit);
        }

        return true;
      }




      componentWillReceiveProps(nextProps){
        this.invokeinitial(nextProps.truemodaledit);
       
      }

      invokeinitial(truemodaledit){
        this.setState({ observacao:"", success: null , error:null,
        });

       

        if(truemodaledit){
          this.setState({ 
            idmatricula:truemodaledit });
        }else{
          this.setState({ 
            idmatricula:truemodaledit });
        }

        this.loadfatura();
      }
       
    
      async loadfatura(){
        const {idmatricula}= this.state;
        const response1 = await api.post("/admin/matricula/id", { idmatricula});

        if(response1.data){
            this.setState({
              open: true, 
              idmatricula:response1.data.id,
              observacao:response1.data.observacao,
            })
        }
       
      }

      componentWillMount(){
     
        this.loadfatura();

      }
      

      editmatricula = async e => {
        e.preventDefault();
        
        const { idmatricula, observacao } = this.state;
       console.log(this.state)
          if (!idmatricula ) {
              this.setState({ error: "Preencha os dados antes de editar!",
            success:null });
              
          } else {

          const response = await api.post("/admin/matricula/editobservacao", {
            idmatricula, observacao
           });
    
            if(response.data.id){
              this.setState({ success: "Observação Editada!" , error:null,
             });

            }else{
              this.setState({ success: null , error:response.data.error,
             });
            }
    
          }
      }
    

      
      


render() {

    const { open } = this.state;


return (
    <React.Fragment>

<div class="sizemodal ">
        <Modal class="col-xl"  open={open} onClose={this.onCloseModal} center>
       <div class="row text-center">
         
          <div class="col-lg-10">
          <h5>Matricula ID #{this.state.idmatricula}</h5>
          <div class="w-100"></div>
          </div>        
        </div>
          <div class="row">
          <div class="col-lg">
          <div class="w-100"></div>

          <form action="#" method="POST" onSubmit={this.editmatricula}>


            <div class="row">

              <div class="col">
                <div class="form-group">
                  <label for="exampleInputEmail1">ID Matricula</label>
                  <input type="text" defaultValue={this.state.idmatricula} readOnly class="form-control" onChange={e => this.setState({ idfatura: e.target.value })} id="exampleInputEmail1" aria-describedby="emailHelp" />
                </div>
              </div>

              
            </div>
  
  
          

  

          <div class='row'>
            <div class="col">
              <div class="form-group">
                <label for="exampleInputEmail1">Anotações</label>
                <textarea rows="5" cols="70" onChange={e => this.setState({ observacao: e.target.value })} 
                defaultValue={this.state.observacao} class="form-control" 
                ></textarea>
                
              </div>
            </div>
          </div>

  


          

  
  <button type="submit" class="btn btn-primary">Atualizar</button>
</form>
             
<center class="text-danger">{this.state.error}</center>
<center class="text-success">{this.state.success}</center>




          </div>

        </div>
       







         

        </Modal>
   
        </div>
    </React.Fragment>
)



}

}

export default withRouter(Map);


// WEBPACK FOOTER //
// ./src/pages/Admin/modulofinanceiro/modalobservacaofatura.js